import { createSlice } from "@reduxjs/toolkit";

import { SettingsCompany } from "@/store/apis/nextcargo";

export const settingsSlice = createSlice({
  name: "settings",
  initialState: {} as SettingsCompany["raw"] satisfies SettingsCompany["raw"],
  reducers: (create) => ({
    setSettings: create.reducer<Partial<SettingsCompany["raw"]>>((state, { payload }) => {
      return {
        ...state,
        ...payload
      };
    }),
    clearSettings: create.reducer(() => ({}) as SettingsCompany["raw"])
  }),
  selectors: {
    selectSettings: (state) => state
  }
});

export const settingsSliceActions = settingsSlice.actions;
export const settingsSliceSelectors = settingsSlice.selectors;
